import { motion } from "framer-motion";

import { anim } from "./utils";
import { useAnimationsEnabled } from "../../lib/hooks/useQueryBoard";

const reveal = {
  initial: { opacity: 0, y: 105 },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      delay: 0.3,
      ease: [0.76, 0, 0.24, 1],
    },
  },
};

const Reveal = (props: {
  children: React.ReactNode;
  disabled?: boolean;
  className?: string;
}) => {
  const { children, disabled, className } = props;

  const animationsEnabled = useAnimationsEnabled();

  if (!animationsEnabled) {
    return children;
  }

  return (
    <div
      style={{
        position: "relative",
        width: "fit-content",
        overflow: "hidden",
      }}
      className={`h-100 ${className}`}
    >
      <motion.div
        {...(!disabled && anim(reveal))}
        className="h-100 d-flex flex-column justify-content-center"
      >
        {children}
      </motion.div>
    </div>
  );
};

export default Reveal;
